import { forwardRef, ReactElement, Ref } from "react";
import { EditGenericWithDestinationWindowTile, EditGenericWithDestinationWindowTilePropsBase } from "./EditGenericWithDestinationWindowTile";
import { EditTileHandle } from "./EditTile";
import { LiquitDetailsTileModel, updateLiquitTile } from "client/Api/Workspace/workspace";

export type EditLiquitTileProps = EditGenericWithDestinationWindowTilePropsBase<LiquitDetailsTileModel>;

export const EditLiquitTile = forwardRef(
	(props: EditLiquitTileProps, ref: Ref<EditTileHandle>): ReactElement => {

		return (
			<EditGenericWithDestinationWindowTile
				{...props}
				requestHandler={updateLiquitTile}
				ref={ref}
			/>
		);
	}
);
EditLiquitTile.displayName = "EditLiquitTile";
